import { Time } from '../../../shared/time/time';

export class Interview {
  constructor(
    public id: number,
    public interviewDate: Date,
    public beginTimeInterview: Time,
    public endTimeInterview: Time,
    public directedById: number,
    public interviewType: string,
    public beneficiaryId: number,
    public interviewThemeId: number | undefined,
    public presence: string,
    public userSiteId: number,
    public receptionSiteId: number,
    public synthesis?: string,
    public note?: string,
    public answerProvidedIds?: number[],
    public structureId?: number,
  ) {}

  public static fromJson(json: any): Interview {
    return new Interview(
      json.id,
      json.interviewDate ? new Date(json.interviewDate) : undefined,
      json.beginTimeInterview,
      json.endTimeInterview,
      json.directedById,
      json.interviewType,
      json.beneficiaryId,
      json.interviewThemeId,
      json.presence,
      json.userSiteId,
      json.receptionSiteId,
      json.synthesis,
      json.note,
      json.answerProvidedIds,
      json.structureId,
    );
  }
}
